<template>

  <div class="mdc-card mgb-24 detail-card">
    <!-- {{ degree }} -->
    <div class="mdc-card__primary-action1 cursor-pointer" tabindex="0" @click="moveLearnView(degree)" :id="`myDegreeCard${degree.id}`">
      <div class="d-flex pdt-24 pdl-24 pdr-24">
        <div class="position-relative mgr-20" v-if="degree.thumbnail">
          <!-- <img
          :src="degree.thumbnail ? degree.thumbnai : `https://s3-ap-northeast-1.amazonaws.com/clpintergrateuploadcontents/_kmath/thumnail.jpg`"
          alt=""> -->
          <img
              :src="degree.thumbnail"
              :alt="degree.name" class="b-radius4 mylearning-img">
          <div class="mdc-chip-set card-chip-right-learning" v-if="degree.thumbnail" role="grid">
            <div class="mdc-chip h-24  bg-shadow2" role="row">
              <div class="mdc-chip__ripple"></div>
              <span role="gridcell">
																	<span role="button"  class="mdc-chip__primary-action">
																		<span class="mdc-chip__text t-helper t-color-white font-r">{{degree.lessonCount > 1 ? $t('69',{str: degree.lessonCount}) : $t('69',{str: degree.lessonCount})}}</span>
																	</span>
													</span>
            </div>
          </div>
          <!-- <div class="detail-status" style="width:156px"></div> -->
          <!-- 5개 강의 -->
          <template v-if="degree.progressRate">
            <div class="divider h-2 position-absolute detail-status-mylearning-wrapper "></div>
            <div class="detail-status-mylearning " :style="`width:${degree.progressRate}%;`"></div>
          </template>

        </div>
        <div class="flex-grow-1">
          <div class="">
            <div class="t-body6 pdr-24 mbg-4 font-r t-color-bodyGrayA mgb-4" v-if="degree && degree.category">
              {{degree.category.text}}{{degree.category.child ? ' > ' + degree.category.child.text : ''}}
            </div>
            <div class="t-headline7  pdr-24 font-m">
              {{degree.name}}
            </div>
          </div>
          <div class="mgt-16">
            <div class="t-body6 pdr-16 t-color-bodyGrayA font-r" v-if="degree && !degree.thumbnail && degree.lessonCount>0">
              {{degree.lessonCount > 0 ? $t('69',{str: degree.lessonCount}) : $t('69',{str: degree.lessonCount})}}
            </div>
            <div  v-if="degree.levels">
												<span class="t-body6  pdr-16 t-color-bodyGrayA font-r t-line-h-18" v-for="(level, index) in degree.levels" :key="index">
														{{level.text}} {{degree.levels.length === index+1 ? '' : '/' }}
												</span>
            </div>
          </div>
          <div class="mgt-2  mgb-20" v-if="degree.teacher">
            <span class="font-r t-color-headlineBlack t-body6 pdr-4">{{$t('70')}} </span><span
              class="font-r t-color-headlineBlack t-body6">{{ degree.teacher.name?$t('3437',{first: degree.teacher.name.first, last: degree.teacher.name.last}):''}}</span>
          </div>

          <div class="d-flex align-items-center justify-content-between pdb-24 pdr-12" v-if="statusTab=='WAITING'" >
            <div class="flex-1  t-color-headlineBlack t-line-h-22 " >
											<span class="t-subtitle3 font-r">
												{{$t('77', {str: $moment(degree.periodLearning.start).format('L')})}}
											</span>
            </div>
          </div>
        </div>



      </div>

    </div>

    <div class="d-flex align-items-baseline justify-content-between pdl-24 pdb-16 pdr-12" v-if="statusTab=='LEARNING'" >
      <div class="flex-1  t-color-headlineBlack t-line-h-35 " v-if="!degree.status" :class="degree.thumbnail ? 'pdl-216' : ''">
        <span class="t-headline3 pdr-2 t-line-h-35 font-b">{{degree.progressRate ? degree.progressRate : '0'}}</span>
        <span class="t-subtitle1 font-b">%</span>
      </div>
      <div class="flex-1  t-color-headlineBlack t-line-h-35 " v-else>
								<span class="t-subtitle1">
										{{$t('77', {str: $moment(degree.startDate).format('L')})}}
								</span>
      </div>
      <div>
        <button class="mdc-icon-button material-icons mdc-card__action mdc-card__action--icon--unbounded degree-card-more-button t-color-bodyGrayA"
                @click="toggleProgress(degree.id)"
                :style="degree.progressViewStatus ? `color: red` : `color:blue`"
                :id="`myDegreeMore${degree.id}`" tabindex="0"
        >
          {{degree.progressViewStatus ? 'expand_less' : 'expand_more'}}
        </button>
      </div>
    </div>



    <div class="d-flex align-items-center justify-content-between pdl-24 pdb-16 pdr-12" v-if="statusTab=='COMPLETION'" >
      <div class="flex-1  t-color-contentBlue t-headline7 font-m l-spacing6 pdb-8"  v-if="degree.learningStatus.value=='COMPLETION'" :class="degree.thumbnail ? 'pdl-216' : ''">
        {{ $t('1307') }}
      </div>
      <div class="flex-1  t-color-red t-headline7 font-m l-spacing6 pdb-8"  v-else :class="degree.thumbnail ? 'pdl-216' : ''">
        {{ $t('1310') }}
      </div>

      <div>
        <button class="mdc-icon-button material-icons mdc-card__action mdc-card__action--icon--unbounded degree-card-more-button t-color-bodyGrayA mgb--12"
                @click="toggleProgress(degree.id)"
                :id="`myDegreeMore${degree.id}`" tabindex="0"
        >
          {{degree.progressViewStatus ? 'expand_less' : 'expand_more'}}
        </button>
      </div>
    </div>

    <component :is="`ListItemProgress`" class="recommand-degree-list"
               :degreeId="degree.id"
               :learnProgressRate="learnProgressRate"
               v-if="degree.progressViewStatus"
    ></component>

  </div>

</template>

<script>
/**
 * 나의 학습 목록 아이템 컴포넌트(my learning main list item component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import { MDCRipple } from "@material/ripple";
import learnApi from "@/api/learnApi.js";
import { MDCChipSet } from "@material/chips";
export default {
  props: ["degree", "status"],
  data() {
    return {
      learnProgressRate: {},
      statusTab: null,
    };
  },

  components: {
    ListItemProgress: () => import("@/components/learn/ListItemProgress.vue"),
  },
  watch: {
    $route(to, from) {
      this.statusTab = this.$route.query.status;
    },
  },
  mounted() {
    this.statusTab = this.$route.query.status;
    const selectorCard = `#myDegreeCard${this.degree.id}`;
    const ripplesCard = [].map.call(
        document.querySelectorAll(selectorCard),
        function (el) {
          return new MDCRipple(el);
        }
    );

    const selectorButton = `#myDegreeMore${this.degree.id}`;
    const ripplesButton = [].map.call(
        document.querySelectorAll(selectorButton),
        function (el) {
          let button = new MDCRipple.attachTo(el);
          button.unbounded = true;
          return button;
        }
    );
    const chipSetEl = document.querySelector(".mdc-chip");
    const chipSet = new MDCChipSet(chipSetEl);
  },

  computed: {},
  methods: {
    // 학습진행율 데이터 (get learning status data)
    toggleProgress(id) {
      console.log(id)
      learnApi
          .learnProgressRate({ id: id })
          .then((response) => {
            this.learnProgressRate = response.data.data;
            this.$emit("initProgressStatus", id);
          })
          .catch((err) => {
            console.log("LEARN PROGRESS RATE ERROR : ", err)
          });
    },

    // move learn view
    moveLearnView(degree) {
      if (degree.learning) {
        localStorage.setItem("learnDetails", "backtoList");
        this.$router.push({
          name: "LearnView",
          query: this.$route.query,
          params: { learnId: degree.id },
        });
      } else {
        this.$alert({
          title: this.$t("72"), // 학습을 중단한 강의입니다.
          content: this.$t("73"), // 환불 요청 또는 신청 취소하여 학습이 중단된 강의는 더 이상 학습하실 수 없습니다.
          accept: this.$t("74"), // 확인
        })
            .then(() => {})
            .catch(() => {});
      }
      // this.$router.push({
      //         name: 'LearnView',
      //         query: this.$route.query,
      //         params: {learnId: degree.id}
      //     })
    },
  },
};
</script>
